export const ORGANIGATIONS = 'ORGANIGATIONS'; // 自定义报表中组织列表
